import { get, remove, set as setCookie, CookieAttributes } from 'js-cookie';

// js-cookie 2.2.1 writes unknown attributes onto document.cookie. SameSite
// is not a built-in option there, but the name is case-insensitive, so
// sameSite=lax is honored by browsers and by Tenable (COMP-50).
function attributes(options?: CookieAttributes): CookieAttributes {
  const protocol = typeof window === 'undefined' ? 'http:' : window.location.protocol;
  return {
    sameSite: 'lax',
    ...(protocol === 'https:' ? { secure: true } : {}),
    ...options,
  };
}

function expire(key: string, options?: CookieAttributes) {
  // Chrome ignores a deletion that lacks Secure when the stored cookie has
  // it, so logout must repeat the attributes used by set.
  remove(key, attributes(options));
}

function isEnabled() {
  if (typeof document === 'undefined') {
    // running in server context
    return false;
  }

  // Emulate the old `enabled` method from `ScottHamper/Cookies` repo,
  // But we'll also check if to see we allow secure, non same-site cookies.
  // @see https://github.com/ScottHamper/Cookies/blob/master/src/cookies.js#L145-L150

  set('cookies', 'true');
  set('cookies-same-site', 'true', { sameSite: 'none', secure: true });
  const exists = get('cookies') ?? get('cookies-same-site');
  expire('cookies');
  expire('cookies-same-site', { sameSite: 'none', secure: true });
  return exists;
}

function set(key: string, value: string, options?: CookieAttributes) {
  return setCookie(key, value, attributes(options));
}

export default {
  isEnabled,
  get,
  set,
  expire,
};
